<template>
  <div class="animated fadeIn">
    <b-row>
     <b-col sm="6" lg="3" v-for="stat in statistics.items" :data="statistics" :key="stat.status_id">
        <b-card no-body :style="{color:'#ffffff', backgroundColor:getColor(stat.status_id)}">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ stat.total_count }}</h4>
            <p>{{ stat.status }}</p>
          </b-card-body>
          <dashboard-chart :dataset="stat.data" :color="getColor(stat.status_id)" :title="stat.status" :label="statistics.label" :chartId="'card-chart-'+ stat.status_id" class="chart-wrapper px-3" style="height:70px;" :height="70"/>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="12">
        <transition name="fade">
          <b-card no-body>
            <div slot="header">
              Notifications
              <div class="card-header-actions">
                <!-- <b-link href="#" class="card-header-action btn-setting">
                  <i class="icon-settings"></i>
                </b-link>
                <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                  <i class="icon-arrow-up"></i>
                </b-link>
                <b-link href="#" class="card-header-action btn-close" v-on:click="show = !show">
                  <i class="icon-close"></i>
                </b-link> -->
              </div>
            </div>
            <b-collapse id="collapse1" visible>
              <b-card-body>
                <request-table></request-table>
              </b-card-body>
            </b-collapse>
          </b-card>
        </transition>
        <!-- <b-card header="Notification Requests">
            <request-table></request-table>
        </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import * as utils from '@/mixins/utils'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import { mapGetters } from 'vuex'
import ReceivedChart from '@/components/dashboard/ReceivedChart'
import SubmittedChart from '@/components/dashboard/SubmittedChart'
import PendingEhocChart from '@/components/dashboard/PendingEhocChart'
import PendingAgencyChart from '@/components/dashboard/PendingAgencyChart'
import CancelledChart from '@/components/dashboard/CancelledChart'

import DashboardChart from '@/components/dashboard/DashboardChart'

import CardLine2ChartExample from '@/components/dashboard/CardLine2ChartExample'
import CardLine3ChartExample from '@/components/dashboard/CardLine3ChartExample'
import CardBarChartExample from '@/components/dashboard/CardBarChartExample'
import MainChartExample from '@/components/dashboard/MainChartExample'
import SocialBoxChartExample from '@/components/dashboard/SocialBoxChartExample'
import CalloutChartExample from '@/components/dashboard/CalloutChartExample'
import { Callout } from '@coreui/vue'
import RequestTable from '@/components/user/DLTTable.vue'

export default {
  name: 'dashboard',
  components: {
    Callout,
    ReceivedChart,
    SubmittedChart,
    PendingEhocChart,
    PendingAgencyChart,
    CancelledChart,
    RequestTable,
    DashboardChart,
  },
  computed: {
    ...mapGetters({     
      statistics: types.GET_DASHBOARD_STATISTICS
    })
  },
  data: function () {
    return {     
    }
  },
  methods: {
    getColor: function(value) {
      let obj = this.$_.find(constants.STATUS_COLOR_CODES, {id:value})
      return obj ? obj.color : "#84ffff";      
    }
  },
  created () {
      this.$store.dispatch(types.ACTION_DASHBOARD_STATISTICS, constants.AGENCY_ADMIN)
      //alert ('token: ' + JSON.parse(window.localStorage.getItem('decon')).token)
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue